module.exports = __webpack_public_path__ + "img/3daa23a.jpg";